import React, { useState } from "react";
import { useEffect } from "react";
import BarChart from "../Charts/BarChart/BarChart";

const AssessmentOverallSummary = ({ data }) => {
  const [chartData, setChartData] = useState([]);
  const [barLabel, setBarLabel] = useState([]);
  const [barColor, setBarColor] = useState([]);

  useEffect(() => {
    data.bar_stats_list.forEach((element) => {
      setChartData((prev) => [...prev, element.value]);
      setBarLabel((prev) => [...prev, element.display_name]);
      setBarColor((prev) => [...prev, element.color_code]);
    });
  }, []);
  return (
    <div className="rounded-[10px] border-solid border-[#b5b5b5] border bg-white">
      <div className="mt-5 mb-4 ml-[50px] text-[#3F3D56]  text-xl leading-5 font-semibold">Assessment summary</div>
      <BarChart
        BarChartData={data}
        chartData={chartData}
        barLabel={barLabel}
        barColor={barColor}
      />
      <div className="flex justify-end gap-[10px] mt-10 mr-5 mb-8">
        {data.legends.map((item, index) => {
          return (
            <div className="flex items-center gap-3 text-base leading-[22px] font-medium text-[#18191A] opacity-70" key={index}>
              <div
                className="h-4 w-9 rounded-[4px]"
                style={{
                  backgroundColor: item.color_code,
                }}
              ></div>{" "}
              {item.legend}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AssessmentOverallSummary;
